<template>
  <div class="page-container legacy-version">
    <div class="content-container"></div>
    <div class="info-container">
      <p>Alias: <span class="mini-info-box">{{ alias }}</span></p>
      <p>Renox Plant ID: <span class="mini-info-box">{{ plantId }}</span></p>
      <p>Time Zone: <span class="mini-info-box">{{timezoneDataMap.timezone_name}}</span></p>
      <p>Local Time: <span class="mini-info-box">
      <LocalTime timeZoneName="Australia/Brisbane" :offset="timezoneDataMap.timezone_offset" /></span></p>

    </div>
    <br>
    <div class="extra-info-container" v-if="access_level == 10">
      <p>Prediction Evaluation</p>
    <button class="custom-button plant-button" @click="isEvalEnabled = !isEvalEnabled">
      {{ isEvalEnabled ? 'Hide' : 'Show' }} 
    </button>
      <p>Plant Devices</p>
      <button class="custom-button plant-button" v-if="!isPlantDevicesDataBoxVisible" @click="loadAndShowPlantDevices">Show</button>
      <button class="custom-button plant-button" v-if="isPlantDevicesDataBoxVisible" @click="this.isPlantDevicesDataBoxVisible = false;">Hide</button> 
   
      <p>User Preferences</p>
      <button class="custom-button plant-button" @click="isUserPreferencesEnabled = !isUserPreferencesEnabled">
        {{ isUserPreferencesEnabled ? 'Hide' : 'Show' }} 
      </button>
       
     </div>
<br>
<div v-if="isUserPreferencesEnabled" class="user-preferences-container">

    <h6>Chart Display Preferences</h6>
    <div class="preferences-grid">
      <div class="preference-item">
        <input 
          type="checkbox" 
          id="predictedBatteryActions"
          v-model="userPreferences.predictedBatteryActions"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="predictedBatteryActions" class="preference-label">
          Predicted Battery Actions
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="predictedBatteryActionsOracle"
          v-model="userPreferences.predictedBatteryActionsOracle"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="predictedBatteryActionsOracle" class="preference-label">
          Oracle Battery Actions
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="pricePrediction"
          v-model="userPreferences.pricePrediction"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="pricePrediction" class="preference-label">
          Price Prediction
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="pvPredictionNonAdjusted"
          v-model="userPreferences.pvPredictionNonAdjusted"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="pvPredictionNonAdjusted" class="preference-label">
          PV Prediction (non-adjusted)
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="loadPredictionLowerBound"
          v-model="userPreferences.loadPredictionLowerBound"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="loadPredictionLowerBound" class="preference-label">
          Load Prediction Lower Bound
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="loadPredictionUpperBound"
          v-model="userPreferences.loadPredictionUpperBound"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="loadPredictionUpperBound" class="preference-label">
          Load Prediction Upper Bound
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="predictedLoadHourly"
          v-model="userPreferences.predictedLoadHourly"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="predictedLoadHourly" class="preference-label">
          Predicted Load Hourly
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="priceActualBuySellRX"
          v-model="userPreferences.priceActualBuySellRX"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="priceActualBuySellRX" class="preference-label">
          Price Actual Buy/Sell (RX)
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="predictedGridPower"
          v-model="userPreferences.predictedGridPower"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="predictedGridPower" class="preference-label">
          Predicted Grid Power
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="actionReasons"
          v-model="userPreferences.actionReasons"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="actionReasons" class="preference-label">
          Action Reasons
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="bmsSimulator"
          v-model="userPreferences.bmsSimulator"
          @change="saveUserPreferences"
          class="preference-checkbox"
        />
        <label for="bmsSimulator" class="preference-label">
          BMS Simulator
        </label>
      </div>

      <div class="preference-item">
        <input 
          type="checkbox" 
          id="useNewDesign"
          :checked="false"
          @change="handleNewDesignToggle"
          class="preference-checkbox"
        />
        <label for="useNewDesign" class="preference-label">
          Use New Design
        </label>
      </div>
    </div>
    
    <div class="preferences-actions">
      <button @click="resetPreferences" class="custom-button reset-button">
        Reset to Defaults
      </button>
    </div>





</div>
<br>
<div v-if="this.isPlantDevicesDataBoxVisible" class="info-container">
      <div class="scrollable-list">
<p v-if="plantDevicesDataMap.length == 0" class="device-info">No device under this plant.</p>
<p v-if="plantDevicesDataMap.length > 0" class="device-info">Number of Devices: {{plantDevicesDataMap.length}}</p>
    <br>
        <div v-for="(device, index) in plantDevicesDataMap" :key="index" class="item">
          <p>Device {{ index + 1 }}</p>
          <br>
          <p>SN: <a :href="'https://redxpower.com/#/device/detail/' + device.device_sn" target="_blank">{{ device.device_sn }}</a></p>
          <br>
          <p>Type: {{ device.device_type }}</p>
          <br>
    </div></div>
 
  </div>
  <br>
    <div>
      <DatePicker v-model:dateValue="selectedDate" />
    </div>
    <LoadingSpinner v-if="isLoadingActualData"></LoadingSpinner>
    <div v-if="isLoading">
    <LoadingBar></LoadingBar>
    </div>
    <div v-if="!isLoading">
    <div class="per-metrics">
      <br>
      <h5>Performance Metrics</h5>
<div class="centered-flex-box">

  <StyledDataBox titleValue="Total Consumption (kWh)" :numberValue="performanceMetricsData['totalConsumption']" descText="*Total daily power usage"
  ></StyledDataBox>
<StyledDataBox titleValue="Usage Cost (AUD)" :numberValue="performanceMetricsData['usageCost']" descText="*Grid import cost"
></StyledDataBox>
<StyledDataBox titleValue="Feed-in Cost (AUD)" :numberValue="performanceMetricsData['feedInCost']" descText="*Grid export earnings"
></StyledDataBox>
<StyledDataBox titleValue="Original Cost (AUD)" :numberValue="performanceMetricsData['originalCost']" subText="AUD per kWh" :subValue="performanceMetricsData['originalCostPerkWh']" descText="*Cost without solar and battery optimisation"
></StyledDataBox>
<StyledDataBox titleValue="Cost with Optimisation (AUD)" :numberValue="performanceMetricsData['costWithOptimisation']" subText="AUD per kWh" :subValue="performanceMetricsData['costWithOptimisationPerkWh']" descText="*After solar and battery optimisation"
></StyledDataBox>
<StyledDataBox titleValue="Net Cost (AUD)" :numberValue="performanceMetricsData['netCostAfterServiceFees']" descText="*Net Cost after Service Fees"
></StyledDataBox>
<StyledDataBox titleValue="Savings (AUD)" :numberValue="performanceMetricsData['savings']" descText="*Saved cost by AI optimisation"
></StyledDataBox>
</div>
    <div class="single-button-container">
            <button @click="navigateToReportPage" class="custom-button">
              Full Performance Report
            </button>
    </div>
    </div>
    <br>
    <div class="custom-divider"></div>
    <div class="chart-container">
    <h5>Power Chart</h5>
    


<div class="extra-details-box">
    <div class="extract-data-container">
      <button class="custom-button" @click="extractChartData('power')">
        Extract Data
      </button>
    </div>
      <div v-if="historicalBatteryActionsTimeList.length > 0 && userPreferences.predictedBatteryActions && access_level == 10" class="version-selector-box">      
      <p>Select Battery Actions Prediction Version</p>
      <select v-model="batteryActionsSelectedTime" @change="handleBatteryActionsTimeSelection" required>
        <option disabled value="">Time</option>
        <option v-for="(time, index) in historicalBatteryActionsTimeList" :key="index" :value="index">
          {{ time }}
        </option>
      </select>
    </div>
    <div class="toggle-button">
      <p>Data Group </p>
      <button
        v-for="option in chartToggleGroupingOptions"
        :key="option"
        :class="{ active: chartToggleGroupingSelectedOption === option }"
        @click="selectToggleGroupingOption(option)"
      >
        {{ option }}
      </button>
    </div>
    <div class="toggle-button">
      <p>Data Type </p>
      <button
        v-for="option in chartToggleDataTypeOptions"
        :key="option"
        :class="{ active: chartToggleDataTypeSelectedOption === option }"
        @click="selectToggleDataTypeOption(option)"
      >
        {{ option }}
      </button>
    </div>
  </div>
  

      <p
        v-if="chartDataPowerPrediction.length === 0 && chartDataPowerActual.length === 0"
        class="display-text-container"
      >
        {{ displayTextPower }}
      </p>
      <CustomChart
      ref="chart1"
        @legends-updated="handlePowerChartHiddenLegendsUpdated"
        @zoom-updated="handleZoomUpdated"
        @pan-updated="handlePanUpdated"
        chartTitle=""
        chartType="line"
        dataUnit="kW"
        :datasets="getPowerDatasets()"
        :hiddenLegends="powerChartHiddenLegends"
      />
    </div> 
    <div v-if="access_level == 10 && isBmsSimulatorEnabled" class="bms-simulator-wrapper">
      <BmsSimulator :plantId="plantId" :dateStr="selectedDate" />
    </div>
    <ActionReasons v-if="isActionReasonsEnabled && access_level == 10" :plantId="plantId" :date="selectedDate" />
    <div class="custom-divider"></div>
    <div class="chart-container">
    <h5>Price Chart</h5>
    
   
    <div class="custom-aligner">
    <div class="extra-details-box">
    <div class="extract-data-container">
      <button class="custom-button" @click="extractChartData('price')">
        Extract Data
      </button>
    </div>
    <div v-if="access_level == 10">
    <DeepPriceAnalysisLink 
    :plantId="plantId"
    :date="selectedDate"
    />
    </div>
      <div v-if="historicalPricePredictionTimeList.length > 0 && userPreferences.pricePrediction && access_level == 10" class="version-selector-box">      
      <p>Select Price Prediction Version</p>
      <select v-model="pricePredictionSelectedTime" @change="handlePricePredictionTimeSelection" required>
        <option disabled value="">Time</option>
        <option v-for="(time, index) in historicalPricePredictionTimeList" :key="index" :value="index">
          {{ time }}
        </option>
      </select>
    </div>
    <div v-if="historicalPricePredictionTimeList.length == 0"></div>
    <div class="toggle-button">
      <button
        v-for="option in chartToggleDataTypeOptions"
        :key="option"
        :class="{ active: chartToggleDataTypeSelectedOption === option }"
        @click="selectToggleDataTypeOption(option)"
      >
        {{ option }}
      </button>
    </div>
</div>

      <p
        class="display-text-container"
        v-if="chartDataPricePrediction.length === 0 && chartDataPriceActual.length === 0"
      >
        {{ displayTextPrice }}
      </p>
      <CustomChart
        ref="chart2"
        @legends-updated="handlePriceChartHiddenLegendsUpdated"
        @zoom-updated="handleZoomUpdated"
        @pan-updated="handlePanUpdated"
        chartTitle=""
        chartType="line"
        dataUnit="AUD"
        :datasets="getPriceDatasets()"        
        :hiddenLegends="priceChartHiddenLegends"
      /></div>
    </div>    
   <div class="custom-divider"></div>
    <div class="chart-container">
    <h5>SoC Chart</h5>
    <div class="extra-details-box">
    <div class="extract-data-container">
      <button class="custom-button" @click="extractChartData('soc')">
        Extract Data
      </button>
    </div>
    </div>
      <p
        class="display-text-container"
        v-if="chartDataSocActual.length === 0 && chartDataSocActual.length === 0"
      >
        {{ displayTextSoc }}
      </p>
      <CustomChart
        ref="chart3"
        @zoom-updated="handleZoomUpdated"
        @pan-updated="handlePanUpdated"
        chartTitle=""
        chartType="line"
        dataUnit="%"
        :datasets="chartDataSocActual"
        :yAxisMin="0"
        :yAxisMax="100"
        :isFilled="true"
      />
    </div>
    <div class="custom-divider"></div>
      <div class="accuracy-eval-box">
      <!-- Loading state -->
      <div v-if="isDataLoading" class="loading-container">
        <p>Loading evaluation data...</p>
        <div class="loading-spinner"></div>
      </div>
      
      <!-- Evaluation components - only show when data is ready -->
      <div v-else-if="isEvalEnabled">
        <AccuracyEval 
          :actual="actualData.pv" 
          :predicted="predictionData.pv_adjusted" 
          :titleSlug="'Prediction Accuracy for Actual PV - Adjusted PV Prediction'"
          v-if="actualData.pv && predictionData.pv_adjusted"
        />
        
        <AccuracyEval 
          :actual="actualData.load" 
          :predicted="predictionData.load" 
          :titleSlug="'Prediction Accuracy for Actual Load - Load Prediction'"
          v-if="actualData.load && predictionData.load"
        />
        
        <AccuracyEval 
          :actual="actualData.battery" 
          :predicted="predictionData.battery" 
          :titleSlug="'Prediction Accuracy for Actual Battery Power - Predicted Battery Actions'"
          v-if="actualData.battery && predictionData.battery"
        />
        
        <AccuracyEval 
          :actual="actualData.buy_price" 
          :predicted="predictionData.buy_price" 
          :titleSlug="'Prediction Accuracy for Actual Buy Price - Predicted Buy Price'"
          v-if="actualData.buy_price && predictionData.buy_price"
        />
        
        <AccuracyEval 
          :actual="actualData.sell_price" 
          :predicted="predictionData.sell_price" 
          :titleSlug="'Prediction Accuracy for Actual Sell Price - Predicted Sell Price'"
          v-if="actualData.sell_price && predictionData.sell_price"
        />
        
        <AccuracyEval 
          :actual="actualData.buy_price" 
          :predicted="predictionData.buy_price_adjusted" 
          :titleSlug="'Prediction Accuracy for Actual Buy Price - Adjusted Buy Price Prediction'"
          v-if="actualData.buy_price && predictionData.buy_price_adjusted"
        />
        
        <AccuracyEval 
          :actual="actualData.sell_price" 
          :predicted="predictionData.sell_price_adjusted" 
          :titleSlug="'Prediction Accuracy for Actual Sell Price - Adjusted Sell Price Prediction'"
          v-if="actualData.sell_price && predictionData.sell_price_adjusted"
        />
      <!-- No data state -->
      <div v-else class="no-data-container">
        <p>No evaluation data available. Please ensure both actual and predicted data are loaded.</p>
      </div>
      </div>
      

    </div>

      <div class="bottom-pillar"></div> 

    </div>
  </div>
  </template>

  <script>
  import base64 from 'base-64';
  import { apiRequest } from '@/services/apiService';
  import CustomChart from '@/components/cards/CustomChart.vue';
  import DatePicker from '../cards/DatePicker.vue';
  import { getToggleDataTypeState, setToggleDataTypeState, getToggleGroupingState, setToggleGroupingState, setPowerChartLegendsState, setPriceChartLegendsState, getPowerChartLegendsState, getPriceChartLegendsState, clearPowerChartLegendsState, clearPriceChartLegendsState, getDevModeState, getUserPreferences, setUserPreferences, getDefaultUserPreferences, getUserInfo, setDetailPageVersion } from '@/services/cookieService';
  import LoadingBar from '../cards/LoadingBar.vue';
  import LoadingSpinner from '../cards/LoadingSpinner.vue';
  import StyledDataBox from '../cards/StyledDataBox.vue';
  import LocalTime from '../cards/LocalTime.vue';
  import ActionReasons from '../cards/ActionReasons.vue';
  import { defineComponent } from "vue";
  import AccuracyEval from "../cards/AccuracyEval.vue";
  import { re } from 'mathjs';
  import { eventBus } from '@/services/eventBus';
  import DeepPriceAnalysisLink from '../cards/DeepPriceAnalysisLink.vue';
  import PerformanceReportPage from '../pages/PerformanceReportPage.vue';
  import BmsSimulator from '../cards/BmsSimulator.vue';
  export default {
    name: 'LegacyDetailPage',
    components: {
      CustomChart,
      DatePicker,
      LoadingBar,
      LoadingSpinner,
      StyledDataBox,
      LocalTime,
      AccuracyEval,
      ActionReasons,
      DeepPriceAnalysisLink,
      PerformanceReportPage,
      BmsSimulator,
    },  

    data() {
      return {
        opacityLevelPrediction: 0.7,
        opacityLevelActual: 0.7,
        plantDevicesDataMap: [],
        isPlantDevicesDataBoxVisible: false,
        timezoneDataMap: {
            timezone_offset: 0,
            timezone_name: '',
        },
        chartToggleGroupingOptions: ["PV", "Load", "Battery", "Grid", "All"],
        chartToggleDataTypeOptions: ["Predicted", "Actual", "Both"],
        powerChartHiddenLegends: [],
        priceChartHiddenLegends: [],
        chartToggleDataTypeSelectedOption: "Predicted",
        chartToggleGroupingSelectedOption: "All",
        displayTextPower: 'No power data to show',
        displayTextPrice: 'No price data to show',
        displayTextSoc: 'No SoC data to show',
        userName: '',
        plantId: 0,
        retailer_id: null,
        date_added: '',
        retailer_name: '',
        selectedDate: this.getDate(),
        chartDataPowerPrediction: [],
        chartDataPowerActual: [],
        chartDataPricePrediction: [],
        historicalPricePredictionIdList: [],
        historicalPricePredictionTimeList: [],
        pricePredictionSelectedTime: '',
        historicalBatteryActionsIdList: [],
        historicalBatteryActionsTimeList: [],
        batteryActionsSelectedTime: '',
        chartDataPriceActual: [],
        chartDataSocActual: [],
        chartLabels: this.prepareLabels(5, 288),
        subDataUrl: "/api/v1.1/data",
        chartZoom: { min: null, max: null },
        sliderValue: 0,
        isLoading: false,      
        performanceMetricsData: {
          totalConsumption: 0,
          usageCost: 0,
          feedInCost: 0,
          originalCost: 0,
          costWithOptimisation: 0,
          originalCostPerkWh: 0,
          costWithOptimisationPerkWh: 0,
          savings: 0,
          netCostAfterServiceFees: 0,
        },
        isLoadingActualData: false,
        isLoadingPredictionData: false,
        actualData: {
          pv: [],
          load: [],
          battery: [],
          buy_price: [],
          sell_price: []
        },
        predictionData: {
          pv_adjusted: [],
          load: [],
          battery: [],
          buy_price: [],
          sell_price: [],
          buy_price_adjusted: [],
          sell_price_adjusted: []
        },
        isEvalEnabled: false,
        isActionReasonsEnabled: false,
        isBmsSimulatorEnabled: false,
        isUserPreferencesEnabled: false,
        userPreferences: getDefaultUserPreferences(),
        access_level: 0,
      };  
    },
    
    computed: {
      // Only show evaluation when both actual and prediction data are loaded
      showEvalResult() {
        return !this.isLoadingActualData && 
              !this.isLoadingPredictionData && 
              this.hasValidDataForEvaluation();
      },

      isDataLoading() {
        return this.isLoadingActualData || this.isLoadingPredictionData;
      }
    },
    
    methods: {
      handleNewDesignToggle(event) {
        const useNewDesign = event.target.checked;
        if (!useNewDesign) return;
        setDetailPageVersion({ version: 'birdsEye' });
        this.$router.push({ name: 'DetailPage', query: this.$route.query });
      },
      navigateToReportPage() {
 
          // Then navigate to performance report
          const queryParams = {
            plant_id: this.plantId
          };
          eventBus.emit('nav-click', 2);
          this.$router.push({ name: 'Performance Report', query: queryParams });
 
      },
      saveUserPreferences() {
        setUserPreferences(this.userPreferences);
        // Update ActionReasons visibility based on preference
        this.isActionReasonsEnabled = this.userPreferences.actionReasons;
        // Update BMS Simulator visibility based on preference
        this.isBmsSimulatorEnabled = this.userPreferences.bmsSimulator;
        // Remove LocalVolt (RX) price series when preference is unchecked
        if (!this.userPreferences.priceActualBuySellRX) {
          this.chartDataPriceActual = this.chartDataPriceActual.filter(
            item => item.group !== 'localvolt_price_actual'
          );
          delete this.actualData['localvolt_buy_price'];
          delete this.actualData['localvolt_sell_price'];
          delete this.actualData['localvolt_time_labels'];
        }
        // Force chart updates by triggering reactivity
        this.$forceUpdate();
      },
      resetPreferences() {
        this.userPreferences = getDefaultUserPreferences();
        setUserPreferences(this.userPreferences);
        this.isActionReasonsEnabled = this.userPreferences.actionReasons;
        this.isBmsSimulatorEnabled = this.userPreferences.bmsSimulator;
        // Force chart updates by triggering reactivity
        this.$forceUpdate();
      },
      loadUserPreferences() {
        this.userPreferences = getUserPreferences();
        this.isActionReasonsEnabled = this.userPreferences.actionReasons;
        this.isBmsSimulatorEnabled = this.userPreferences.bmsSimulator;
      },
      filterDatasetsByPreferences(datasets) {
        if (!datasets || !Array.isArray(datasets)) return [];
        
        return datasets.filter(dataset => {
          const name = dataset.name.toLowerCase();
          const group = dataset.group.toLowerCase();
          
          // Check each preference condition
          if (name.includes('predicted battery actions') && !name.includes('oracle')) {
            return this.userPreferences.predictedBatteryActions;
          }
          if (name.includes('oracle battery actions')) {
            return this.userPreferences.predictedBatteryActionsOracle;
          }
          if (group.includes('price_prediction') || name.includes('predicted price')) {
            return this.userPreferences.pricePrediction;
          }
          if (name.includes('predicted pv power') && !name.includes('adjusted')) {
            return this.userPreferences.pvPredictionNonAdjusted;
          }
          if (name.includes('predicted load lower')) {
            return this.userPreferences.loadPredictionLowerBound;
          }
          if (name.includes('predicted load upper')) {
            return this.userPreferences.loadPredictionUpperBound;
          }
          if (name.includes('predicted load') && name.includes('hourly')) {
            return this.userPreferences.predictedLoadHourly;
          }
          if (name.includes('actual price') && name.includes('(rx)')) {
            return this.userPreferences.priceActualBuySellRX;
          }
          if (name.includes('predicted grid power')) {
            return this.userPreferences.predictedGridPower;
          }
          
          // Return true for datasets not controlled by preferences
          return true;
        });
      },
      // Add error boundary method
      errorCaptured(err, instance, info) {
        console.log('Error caught in DetailPage:', err, info);
        return false; // Prevent the error from propagating
      },
      hasValidDataForEvaluation() {
        // Check if we have valid data for evaluation
        return this.actualData && this.predictionData &&
              Object.keys(this.actualData).length > 0 &&
              Object.keys(this.predictionData).length > 0;
      },

    handleEnvironmentChange(isDevMode) {
      // console.log("isDevMode:", isDevMode);
      this.subDataUrl = isDevMode ? "/dev-api/api/v1.1/data" : "/api/v1.1/data";
      // Trigger a refresh of the data when environment changes
      this.triggerAllFetches();
    },
    handleZoomUpdated({ min, max, sliderValue }) {
      this.chartZoom = { min, max };
      this.sliderValue = sliderValue;
      // Update other charts with the new zoom values and slider value
      this.updateCharts({ min, max, sliderValue });
    },
    handlePanUpdated({ min, max, sliderValue }) {
      this.chartZoom = { min, max };
      this.sliderValue = sliderValue;
      // Update other charts with the new pan values and slider value
      this.updateCharts({ min, max, sliderValue });
    },
    updateCharts({ min, max, sliderValue }) {
      if (this.$refs.chart1) {
        this.$refs.chart1.updateChart({ min, max, sliderValue });
      }
      if (this.$refs.chart2) {
        this.$refs.chart2.updateChart({ min, max, sliderValue });
      }
      if (this.$refs.chart3) {
        this.$refs.chart3.updateChart({ min, max, sliderValue });
      }
    },

  handlePowerChartHiddenLegendsUpdated(hiddenLegends) {

      // Save to cookie                                                                           
      setPowerChartLegendsState({powerHiddenLegends: JSON.stringify(hiddenLegends) });
    },
    handlePriceChartHiddenLegendsUpdated(hiddenLegends) {

      // Save to cookie
      setPriceChartLegendsState({priceHiddenLegends: JSON.stringify(hiddenLegends) });

    },
    readFromCookies() {
      const toggleDataTypeCookieData = getToggleDataTypeState();

      if (toggleDataTypeCookieData && toggleDataTypeCookieData.chartToggleDataTypeValue !== undefined && toggleDataTypeCookieData.chartToggleDataTypeValue !== null && toggleDataTypeCookieData.chartToggleDataTypeValue !== '') {
        this.chartToggleDataTypeSelectedOption = toggleDataTypeCookieData.chartToggleDataTypeValue;
      }

      const toggleGroupingCookieData = getToggleGroupingState();

      if (toggleGroupingCookieData && toggleGroupingCookieData.chartToggleGroupingValue !== undefined && toggleGroupingCookieData.chartToggleGroupingValue !== null && toggleGroupingCookieData.chartToggleGroupingValue !== '') {
        this.chartToggleGroupingSelectedOption = toggleGroupingCookieData.chartToggleGroupingValue;
      }

      const powerChartLegendsCookieData = getPowerChartLegendsState();

      if (powerChartLegendsCookieData && powerChartLegendsCookieData.powerHiddenLegends !== undefined && powerChartLegendsCookieData.powerHiddenLegends !== 'undefined' && powerChartLegendsCookieData.powerHiddenLegends !== null && powerChartLegendsCookieData.powerHiddenLegends !== '') {
        this.powerChartHiddenLegends = JSON.parse(powerChartLegendsCookieData.powerHiddenLegends);
      
        this.powerChartHiddenLegends = this.powerChartHiddenLegends.filter(item => item != null);
      }

      const priceChartLegendsCookieData = getPriceChartLegendsState();

      if (priceChartLegendsCookieData && priceChartLegendsCookieData.priceHiddenLegends !== undefined && priceChartLegendsCookieData.priceHiddenLegends !== 'undefined' && priceChartLegendsCookieData.priceHiddenLegends !== null && priceChartLegendsCookieData.priceHiddenLegends !== '') {
        this.priceChartHiddenLegends = JSON.parse(priceChartLegendsCookieData.priceHiddenLegends);

        this.priceChartHiddenLegends = this.priceChartHiddenLegends.filter(item => item != null);
      }

      // Initialize subDataUrl based on dev mode state from cookies
      const devModeState = getDevModeState();
      if (devModeState.isDevMode !== undefined) {
        this.subDataUrl = devModeState.isDevMode ? "/dev-api/api/v1.1/data" : "/api/v1.1/data";
      }

      // Load user preferences from cookies
      this.loadUserPreferences();

      // Load access level from cookies
      let cookieData = getUserInfo();
      if (cookieData) {
        this.access_level = cookieData.accessLevel;
      }
    },
    handlePricePredictionTimeSelection() {
      this.fetchPricePredictionsById(this.historicalPricePredictionIdList[this.pricePredictionSelectedTime]);
    },
    handleBatteryActionsTimeSelection() {
      this.fetchBatteryActionsById(this.historicalBatteryActionsIdList[this.batteryActionsSelectedTime]);
      this.calculateGridPowerPredictions();
    },

    getMaxValueFromPriceDatasets() {
      const datasets = this.getPriceDatasets() || []; // Ensure datasets is always an array
      let allValues = [];
      
      if (datasets.length > 0) { // Check if datasets is not empty
        datasets.forEach(dataset => {
          if (dataset.values && dataset.values.length > 0) {
            allValues = allValues.concat(dataset.values);
          }
        });
      }

      return allValues.length > 0 ? Math.max(...allValues) : null; // or a default value like 0
    },


    getPowerDatasets() {
      // Helper function to get sort order based on group name
      const getGroupOrder = (groupName) => {
        const name = groupName.toLowerCase();
        if (name.includes('pv')) return 1;
        if (name.includes('load')) return 2;
        if (name.includes('battery')) return 3;
        if (name.includes('grid')) return 4;
        return 5; // For any other groups
      };

      // Helper function to sort datasets
      const sortDatasets = (datasets) => {
        return datasets.sort((a, b) => {
          const orderA = getGroupOrder(a.group);
          const orderB = getGroupOrder(b.group);
          return orderA - orderB;
        });
      };

      // console.log("chartDataPowerPrediction:", this.chartDataPowerPrediction);
      if (this.chartToggleGroupingSelectedOption === "All") {
        if (this.chartToggleDataTypeSelectedOption === "Predicted") {
          const datasets = Array.isArray(this.chartDataPowerPrediction) ? this.chartDataPowerPrediction : [];
          const filtered = this.filterDatasetsByPreferences(datasets);
          return sortDatasets(filtered);
        } else if (this.chartToggleDataTypeSelectedOption === "Actual") {
          const datasets = Array.isArray(this.chartDataPowerActual) ? this.chartDataPowerActual : [];
          const filtered = this.filterDatasetsByPreferences(datasets);
          return sortDatasets(filtered);
        } else if (this.chartToggleDataTypeSelectedOption === "Both") {
          const predicted = Array.isArray(this.chartDataPowerPrediction) ? this.chartDataPowerPrediction : [];
          const actual = Array.isArray(this.chartDataPowerActual) ? this.chartDataPowerActual : [];
          const combined = predicted.concat(actual);
          const filtered = this.filterDatasetsByPreferences(combined);
          return sortDatasets(filtered);
        } else {
          return [];
        }
      } else {
        const predicted = Array.isArray(this.chartDataPowerPrediction) ? this.chartDataPowerPrediction : [];
        const actual = Array.isArray(this.chartDataPowerActual) ? this.chartDataPowerActual : [];
        let combinedDataArray = predicted.concat(actual);
        
        if (this.chartToggleGroupingSelectedOption != "All") {
          combinedDataArray = combinedDataArray.filter(item => {
            return item['group'].toLowerCase().slice(0, this.chartToggleGroupingSelectedOption.length) === this.chartToggleGroupingSelectedOption.toLowerCase();
          });
          const filtered = this.filterDatasetsByPreferences(combinedDataArray);
          return sortDatasets(filtered);
        }
        return [];
      }
    },

    getPriceDatasets() {
      if (this.chartToggleDataTypeSelectedOption === "Predicted") {
        const datasets = Array.isArray(this.chartDataPricePrediction) ? this.chartDataPricePrediction : [];
        return this.filterDatasetsByPreferences(datasets);
      } else if (this.chartToggleDataTypeSelectedOption === "Actual") {
        const datasets = Array.isArray(this.chartDataPriceActual) ? this.chartDataPriceActual : [];
        return this.filterDatasetsByPreferences(datasets);
      } else if (this.chartToggleDataTypeSelectedOption === "Both") {
        const predicted = Array.isArray(this.chartDataPricePrediction) ? this.chartDataPricePrediction : [];
        const actual = Array.isArray(this.chartDataPriceActual) ? this.chartDataPriceActual : [];
        const combined = predicted.concat(actual);
        return this.filterDatasetsByPreferences(combined);
      } else {
        return [];
      }
    },


    selectToggleDataTypeOption(option) {
      //// Reset the data grouping to All
      this.chartToggleGroupingSelectedOption = "All";
      setToggleGroupingState({chartToggleGroupingValue: this.chartToggleGroupingSelectedOption});

      this.hiddenLegends = [];
      this.chartToggleDataTypeSelectedOption = option;

      setToggleDataTypeState({chartToggleDataTypeValue: this.chartToggleDataTypeSelectedOption});
      this.readFromCookies();
    },
    selectToggleGroupingOption(option) {
      //// Reset the data type to Both 
      this.hiddenLegends = [];
      this.chartToggleDataTypeSelectedOption = 'Both';
      setToggleDataTypeState({chartToggleDataTypeValue: this.chartToggleDataTypeSelectedOption});

      //// Handle data grouping
      this.chartToggleGroupingSelectedOption = option;
      setToggleGroupingState({chartToggleGroupingValue: this.chartToggleGroupingSelectedOption});
      this.readFromCookies();
    },
    removeGroup(targetGroup, targetDataset) {
      if (targetDataset === "power") {
        this.chartDataPowerPrediction = this.chartDataPowerPrediction.filter(item => item.group !== targetGroup);
      }
    },
    resetAllDataLists() {
      this.chartDataPowerPrediction = [];
      this.chartDataPowerActual = [];
      this.chartDataPricePrediction = [];
      this.chartDataPriceActual = [];
      this.chartDataSocActual = [];
    },  
    triggerAllFetches() {  
      this.resetAllDataLists();
      this.readFromCookies();
      this.fetchPvPredictions();
      this.fetchPricePredictions();
      this.fetchPriceActualData();
      this.fetchLoadPredictions();
      this.fetchActualDataFromRedx();
      this.fetchBatteryActionPredictions();
      this.getPerformanceMetricsData();
      this.getTimezoneData();
      this.fetchHistoricalPricePredictions();
      this.fetchHistoricalBatteryActionPredictions();
      // this.fetchGridPowerPredictions();
      this.calculateGridPowerPredictions();
      if (this.userPreferences.priceActualBuySellRX) {
        this.fetchLocalVoltPriceDataFromRedxProxy();
      }
      this.isLoadingPredictionData = false;
      
      setTimeout(() => {
        this.isLoading = false;
      }, 300);
      // console.log("This is actual data: ", this.actualData);
      // console.log("This is prediction data: ", this.predictionData);
      
    },
    getQueryParams() {
      this.alias = this.$route.query.alias;
      this.plantId = Number(this.$route.query.plant_id);
      this.retailer_id = this.$route.query.retailer_id ? Number(this.$route.query.retailer_id) : null;
      const dateQ = this.$route.query.date_added;
      this.date_added = Array.isArray(dateQ) ? (dateQ[0] ?? '') : (dateQ ?? '');
      const retailerNameQ = this.$route.query.retailer_name;
      this.retailer_name = Array.isArray(retailerNameQ) ? (retailerNameQ[0] ?? '') : (retailerNameQ ?? '');
    },
    getDate() {
      // Check if URL has date parameter first
      const urlParams = new URLSearchParams(window.location.search);
      const dateFromUrl = urlParams.get('date');
      if (dateFromUrl) {
        return dateFromUrl;
      }

      // If no date in URL, use today's date
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    prepareLabels(intervalInMins, length) {
      const labels = [];
      let minutes = 0;

      for (let i = 0; i < length; i++) {
        const hours = Math.floor(minutes / 60).toString().padStart(2, '0');
        const mins = (minutes % 60).toString().padStart(2, '0');
        labels.push(`${hours}:${mins}`);
        minutes += intervalInMins; // Increment by the interval
      }

      return labels;
    },
    debounce(func, wait) {
      let timeout;
      return function(...args) {
        // Clear the timeout
        clearTimeout(timeout);
        // Set a new timeout
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
    async fetchActualDataFromRedx() {
      try {
        this.chartDataPowerActual = [];
        this.chartDataSocActual = [];
        this.isLoadingActualData = true;
        // const bodyData = {
        //   date: this.selectedDate,
        //   plant_id: this.plantId,
        // };
        // const url = `${this.subDataUrl}/bridge/rx_data/plant/daily_data/get`;
        const bodyData = {
          plantId: this.plantId,
          logDate: this.selectedDate.replace(/-/g, '_'),
        };
        const url = `${this.subDataUrl}/proxy/rx/plant/get_daily_data`;
        
        const response = await apiRequest('post', url, bodyData);
      
        if (response.errorCode === 0 && response.data) {
        
          const actualPower = response.data;
          this.isLoadingActualData = false;
          if (actualPower.length > 0) {
            const seriesLabels = {
              batP: 'Actual Battery Power',
              gridP: 'Actual Grid Power',
              loadP: 'Actual Load Power',
              ppv: 'Actual PV Power',
              soc: 'Actual SoC'
            };
            const seriesColors = {
              batP: `rgba(200, 20, 150, ${this.opacityLevelActual})`,
              gridP: `rgba(54, 162, 235, ${this.opacityLevelActual})`,
              loadP: `rgba(153, 102, 255, ${this.opacityLevelActual})`,
              ppv: `rgba(75, 192, 50, ${this.opacityLevelActual})`,
              soc: `rgba(54, 162, 235, ${this.opacityLevelActual})`,
            };
            const batPData = [];
            const gridPData = [];
            const loadPData = [];
            const ppvData = [];
            const socData = [];

            // // Loop through the actual data and map it to the correct index in chartLabels
            // actualPower.forEach((dataPoint) => {
            //   const { batP, gridP, loadP, ppv, soc, logtime } = dataPoint;
              
            //   // Find the index of the logtime in chartLabels
            //   const index = this.chartLabels.indexOf(logtime);
              
            //   // Only update if the logtime exists in chartLabels
            //   if (index !== -1) {
            //     batPData[index] = (parseFloat(batP) / 1000).toFixed(2);
            //     gridPData[index] = (parseFloat(gridP) / 1000).toFixed(2);
            //     loadPData[index] = (parseFloat(loadP) / 1000).toFixed(2);
            //     ppvData[index] = (parseFloat(ppv) / 1000).toFixed(2);
            //     socData[index] = parseFloat(soc).toFixed(2);
            //   }
            // });

            //// Optimized for proxy START
            // Loop through the actual data and map it to the correct index in chartLabels
            actualPower.forEach((dataPoint) => {
              const { batP, gridP, loadP, ppv, soc, logTime } = dataPoint;
              
              // Find the index of the logtime in chartLabels
              const index = this.chartLabels.indexOf(logTime);
              
              // Only update if the logtime exists in chartLabels
              if (index !== -1) {
                batPData[index] = (parseFloat(batP)).toFixed(2);
                gridPData[index] = (parseFloat(gridP)).toFixed(2);
                loadPData[index] = (parseFloat(loadP)).toFixed(2);
                ppvData[index] = (parseFloat(ppv)).toFixed(2);
                socData[index] = parseFloat(soc).toFixed(2);
              }
            });

            // Optimized for proxy END

            // actualPower.forEach((dataPoint) => {
            //   const { batP, gridP, loadP, ppv, soc } = dataPoint;
            //   batPData.push((parseFloat(batP) / 1000).toFixed(2));
            //   gridPData.push((parseFloat(gridP) / 1000).toFixed(2));
            //   loadPData.push((parseFloat(loadP) / 1000).toFixed(2));
            //   ppvData.push((parseFloat(ppv) / 1000).toFixed(2));
            //   socData.push(parseFloat(soc).toFixed(2));
            // });


            // //// Optimized for bridge START
            // // Loop through the actual data and map it to the correct index in chartLabels
            // actualPower.forEach((dataPoint) => {
            //   const { batP, gridP, loadP, ppv, soc, logtime } = dataPoint;
              
            //   // Find the index of the logtime in chartLabels
            //   const index = this.chartLabels.indexOf(logtime);
              
            //   // Only update if the logtime exists in chartLabels
            //   if (index !== -1) {
            //     batPData[index] = (parseFloat(batP)).toFixed(2);
            //     gridPData[index] = (parseFloat(gridP)).toFixed(2);
            //     loadPData[index] = (parseFloat(loadP)).toFixed(2);
            //     ppvData[index] = (parseFloat(ppv)).toFixed(2);
            //     socData[index] = parseFloat(soc).toFixed(2);
            //   }
            // });

            // //// Optimized for bridge END


            this.chartDataPowerActual = [];
            this.chartDataSocActual = [];
            this.chartDataPowerActual = [
              { group: 'battery_actual', name: seriesLabels.batP, values: batPData, color: seriesColors.batP, labels: this.chartLabels },
              { group: 'grid_actual', name: seriesLabels.gridP, values: gridPData, color: seriesColors.gridP, labels: this.chartLabels },
              { group: 'load_actual', name: seriesLabels.loadP, values: loadPData, color: seriesColors.loadP, labels: this.chartLabels },
              { group: 'pv_actual', name: seriesLabels.ppv, values: ppvData, color: seriesColors.ppv, labels: this.chartLabels },
            ];
            this.actualData['pv'] = ppvData;
            this.actualData['load'] = loadPData;
            this.actualData['battery'] = batPData;


            this.chartDataSocActual = [{ group: 'soc_actual', name: seriesLabels.soc, values: socData, color: seriesColors.soc, labels: this.chartLabels },
            ];
            this.fetchBatteryActionOracleData();
          } else {
            this.isLoadingActualData = false;
            // console.log('fetchActualDataFromRenox No prod plant data found in the response.');
          }
        } else {
          this.isLoadingActualData = false;
          // console.log('fetchActualDataFromRenox No prod plant data found in the response.');
        }
      } catch (error) {
        this.isLoadingActualData = false;
        // console.log('fetchActualDataFromRenox Error fetching prod plant data:', error);
      }
    },
    async fetchPriceActualData() {
      try {
          this.chartDataPriceActual = [];
          const bodyData = {
              date: this.selectedDate,
              plant_id: this.plantId,
          };
          const url = `${this.subDataUrl}/price_actual/get`;
          const response = await apiRequest('post', url, bodyData);
          
          if (response.errorCode === 0 && response.data) {
              const actual_price_values = response.data;
              const actualPriceBuyValues = actual_price_values.price_buy_values;
              const actualPriceSellValues = actual_price_values.price_sell_values;
              
              const dataTypes = actual_price_values.data_types || []; // Get data_types array

              this.chartDataPriceActual = [];
              
              // Create the main price lines
              this.chartDataPriceActual.push(
                  {
                      group: 'price_actual',
                      name: 'Actual Price Buy',
                      values: actualPriceBuyValues,
                      color: `rgba(153, 102, 255, ${this.opacityLevelActual})`,
                      labels: this.chartLabels,
                  },
                  {
                      group: 'price_actual',
                      name: 'Actual Price Sell',
                      values: actualPriceSellValues,
                      color: `rgba(255, 159, 64, ${this.opacityLevelActual})`,
                      labels: this.chartLabels,
                  }
              );

             
              
              // Add warning indicators for unreliable data points (data_type = 1)
              if (dataTypes.length > 0) {
                  const unreliableBuyPoints = [];
                  const unreliableSellPoints = [];
                  
                  dataTypes.forEach((dataType, index) => {
                      if (dataType === 1) {
                          // Add the actual values for unreliable points
                          unreliableBuyPoints.push(actualPriceBuyValues[index]);
                          unreliableSellPoints.push(actualPriceSellValues[index]);
                      } else {
                          // Add null for reliable points (won't be displayed)
                          unreliableBuyPoints.push(null);
                          unreliableSellPoints.push(null);
                      }
                  });
                  
                  // Add warning indicator series for Buy prices
                  this.chartDataPriceActual.push({
                      group: 'price_actual_warnings',
                      name: 'Last Known Buy Price 🚩 ',
                      values: unreliableBuyPoints,
                      color: 'rgba(255, 0, 0, 0.8)', // Red color for warnings
                      labels: this.chartLabels,
                      type: 'scatter', // Use scatter plot for individual markers
                      marker: {
                          symbol: 'triangle-up',
                          size: 8,
                          color: 'rgba(255, 0, 0, 0.8)'
                      },                      
                  });
                  
                  // Add warning indicator series for Sell prices
                  this.chartDataPriceActual.push({
                      group: 'price_actual_warnings',
                      name: 'Last Known Sell Price 🚩 ',
                      values: unreliableSellPoints,
                      color: 'rgba(255, 0, 0, 0.8)', // Red color for warnings
                      labels: this.chartLabels,    
                      marker: {
                          symbol: 'triangle-up',
                          size: 8,
                          color: 'rgba(255, 0, 0, 0.8)'
                      },                     
                  });
              }

              this.actualData['buy_price'] = actualPriceBuyValues;
              this.actualData['sell_price'] = actualPriceSellValues;
              this.actualData['data_types'] = dataTypes;
              
              
          } else {
              //console.log('No data found in the response.');
          }
      } catch (error) {
          //console.log('Error fetching price actual values:', error);
      }
  },
   async fetchLocalVoltPriceDataFromRedxProxy() {
      try {
          const bodyData = {
              date: this.selectedDate,
              plantId: this.plantId,
          };
          
          // Remove all items with group 'localvolt_price_actual'
          this.chartDataPriceActual = this.chartDataPriceActual.filter(
              item => item.group !== 'localvolt_price_actual'
          );
          
          const url = `${this.subDataUrl}/proxy/rx/localvoltapi/localvolt/get_price`;
          const response = await apiRequest('post', url, bodyData);
          
          if (response.errorCode === 0 && response.data) {
              const localVoltData = response.data || [];
              
              // Filter data to only include items where intervalEnd date matches selectedDate
              const filteredLocalVoltData = localVoltData.filter(item => {
                  if (item && item.intervalEnd) {
                      const intervalEndDate = item.intervalEnd.split(' ')[0]; // Extract date part "YYYY-MM-DD"
                      return intervalEndDate === this.selectedDate;
                  }
                  return false;
              });
              
              // Generate complete 5-minute interval timeline for 24 hours (288 intervals)
              const generateTimeIntervals = () => {
                  const intervals = [];
                  for (let hour = 0; hour < 24; hour++) {
                      for (let minute = 0; minute < 60; minute += 5) {
                          const timeStr = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                          intervals.push(timeStr);
                      }
                  }
                  return intervals;
              };
              
              const allTimeIntervals = generateTimeIntervals();
              
              // Create a map of existing data by time (using filtered data)
              const dataMap = new Map();
              filteredLocalVoltData.forEach(item => {
                  if (item && item.intervalEnd) {
                      const timeStr = item.intervalEnd.split(' ')[1].substring(0, 5); // "00:05"
                      dataMap.set(timeStr, {
                          earningsFlexUp: item.earningsFlexUp || 0,
                          costsFlexUp: item.costsFlexUp || 0
                      });
                  }
              });
              
              // Fill arrays with data or 0 for missing intervals
              const localVoltBuyValues = [];
              const localVoltSellValues = [];
              const localVoltTimeLabels = [];
              
              allTimeIntervals.forEach(timeStr => {
                  const data = dataMap.get(timeStr);
                  // Convert cents to AUD (divide by 100) and round to 2 decimal places
                  const buyValue = data ? parseFloat((data.costsFlexUp / 100).toFixed(2)) : 0;
                  const sellValue = data ? parseFloat((data.earningsFlexUp / 100).toFixed(2)) : 0;
                  
                  localVoltBuyValues.push(buyValue);
                  localVoltSellValues.push(sellValue);
                  localVoltTimeLabels.push(timeStr);
              });

              // Shift one step to the left and remove the last value (To align it with Dr Lee's request)
              // localVoltBuyValues.shift();
              // localVoltSellValues.shift();
              // localVoltBuyValues.push(0);
              // localVoltSellValues.push(0);
                      
              
              // Remove all items with group 'localvolt_price_actual'
              this.chartDataPriceActual = this.chartDataPriceActual.filter(
                  item => item.group !== 'localvolt_price_actual'
              );
              
              // Push LocalVolt data to the same chartDataPriceActual array
              this.chartDataPriceActual.push(
                  {
                      group: 'localvolt_price_actual',
                      name: 'Actual Price Buy (RX)',
                      values: localVoltBuyValues,
                      color: `rgba(54, 162, 235, ${this.opacityLevelActual})`, // Blue
                      labels: localVoltTimeLabels,
                  },
                  {
                      group: 'localvolt_price_actual',
                      name: 'Actual Price Sell (RX)',
                      values: localVoltSellValues,
                      color: `rgba(255, 99, 132, ${this.opacityLevelActual})`, // Red color
                      labels: localVoltTimeLabels,
                  }
              );
              
              // Store in actualData for reference
              this.actualData['localvolt_buy_price'] = localVoltBuyValues;
              this.actualData['localvolt_sell_price'] = localVoltSellValues;
              this.actualData['localvolt_time_labels'] = localVoltTimeLabels;
              
          } else {
              // console.log('No LocalVolt data found in the response.');
          }
      } catch (error) {
          // console.log('Error fetching LocalVolt price data:', error);
      }
    },
    async fetchBatteryActionPredictions() {
      try {
        this.removeGroup('battery_actions_prediction', 'power');
        const bodyData = {
          date: this.selectedDate,
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/battery_actions/get`;
        const response = await apiRequest('post', url, bodyData);
        if (response.errorCode === 0 && response.data) {
          const battery_actions = response.data;
          if (battery_actions.length > 0) {
            const actionPowerData = battery_actions[0].action_power;
            const decodedActionPower = this.decodeModelData(actionPowerData);

            this.removeGroup('battery_actions_prediction', 'power');
            this.chartDataPowerPrediction.push({
              group: 'battery_actions_prediction',
              name: 'Predicted Battery Actions',
              values: decodedActionPower,
              color: `rgba(200, 20, 150, ${this.opacityLevelPrediction})`,
              labels: this.chartLabels,
            });
            this.predictionData['battery'] = decodedActionPower;

          } else {
            //console.log('No battery_actions prediction found in the response.');
          }
        } else {
          //console.log('No battery_actions prediction data found in the response.');
        }
      } catch (error) {
        //console.log('Error fetching battery_actions prediction:', error);
      }
    },
    async fetchBatteryActionOracleData() {
      try {
        this.actualData['battery_actions_oracle'] = [];
        this.removeGroup('battery_actions_oracle_actual', 'power');
        const bodyData = {
          date: this.selectedDate,
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/battery_actions_oracle/get`;
        const response = await apiRequest('post', url, bodyData);
        if (response.errorCode === 0 && response.data) {
          const battery_actions_oracle = response.data;
          if (battery_actions_oracle.length > 0) {
            const oracleActionPowerData = battery_actions_oracle[0].action_power;
            const decodedOracleActionPower = this.decodeModelData(oracleActionPowerData);

            this.actualData['battery_actions_oracle'] = decodedOracleActionPower;  
            this.chartDataPowerActual.push({
            group: 'battery_actions_oracle_actual',
            name: 'Oracle Battery Actions',
            values: decodedOracleActionPower,
            color: `rgba(255, 165, 0, ${this.opacityLevelPrediction})`,
            labels: this.chartLabels,
          });
          // console.log('This is the oracle actual data: ', this.actualData['battery_actions_oracle']);

          } else {
            //console.log('No battery_actions_oracle found in the response.');
          }
        } else {
          //console.log('No battery_actions_oracle data found in the response.');
        }
      } catch (error) {
        //console.log('Error fetching battery_actions_oracle:', error);
      }
    },

    decodeModelData(encodedData) {
      // Helper function to try decoding a base64 chunk
      const tryDecodingChunk = (chunk) => {
        try {
          const decoded = base64.decode(chunk);
          
          // First try parsing as JSON
          try {
            return { success: true, data: JSON.parse(decoded) };
          } catch {
            // If JSON parsing fails, try parsing as comma-separated numbers
            const numericString = decoded.toString().trim();
            if (numericString.match(/^[\d.,\s]+$/)) {
              const numbers = numericString
                .split(',')
                .map(n => parseFloat(n.trim()))
                .filter(n => !isNaN(n));
              
              if (numbers.length > 0) {
                return { success: true, data: numbers };
              }
            }
            return { success: false };
          }
        } catch {
          return { success: false };
        }
      };
      // Try to find the longest valid chunk that contains numeric data
      const chunks = encodedData.split(/[^A-Za-z0-9+/=]/);
      let bestResult = { success: false, data: null };
      let maxLength = 0;

      for (const chunk of chunks) {
        // Skip obviously invalid base64
        if (chunk.length < 4) continue;
        
        const result = tryDecodingChunk(chunk);
        if (result.success) {
          const dataLength = Array.isArray(result.data) ? result.data.length : 1;
          if (dataLength > maxLength) {
            maxLength = dataLength;
            bestResult = result;
          }
        }
      }

      return bestResult.success ? bestResult.data : null;
    },
    async fetchPvPredictions() {
      try {
        this.removeGroup('pv_prediction', 'power');
        const bodyData = {
          model_date: this.selectedDate,
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/pv_prediction/get`;
        const response = await apiRequest('post', url, bodyData);
        if (response.errorCode == 0 && response.data != null) {
          const predictions = response.data;
          if (predictions.length > 0) {
            const modelPvData = predictions[0].model_pv;
            const decodedPv = this.decodeModelData(modelPvData);
            const modelAdjustedPvData = predictions[0].model_adjusted_pv;
            const decodedAdjustedPv = this.decodeModelData(modelAdjustedPvData);
            
            this.removeGroup('pv_prediction', 'power');
            this.chartDataPowerPrediction.push({
              group: 'pv_prediction',
              name: 'Predicted PV Power',
              values: decodedPv,
              color: `rgba(75, 192, 50, ${this.opacityLevelPrediction})`,
              labels: this.chartLabels,
            });
            this.predictionData['pv'] = decodedPv;

            if(decodedAdjustedPv.length > 0) {
            this.chartDataPowerPrediction.push({
              group: 'pv_prediction_adjusted',
              name: 'Predicted PV Power (adjusted)',
              values: decodedAdjustedPv,
              color: `rgba(75, 192, 50, ${this.opacityLevelPrediction})`,
              labels: this.chartLabels,
            });
            this.predictionData['pv_adjusted'] = decodedAdjustedPv;
            }
          } else {
            //console.log('No predictions found in the response.');
          }
        } else {
          //console.log('No data found in the response.');
        }
      } catch (error) {
        //console.log('Error fetching PV predictions:', error);
      }
    },
    
    async fetchPricePredictions() {
      try {
        this.chartDataPricePrediction = [];
        const bodyData = {
          model_date: this.selectedDate,
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/price_prediction/get`;
        const response = await apiRequest('post', url, bodyData);
        if (response.errorCode === 0 && response.data) {
          const predictions = response.data;
          if (predictions.length > 0) {
            const modelPriceBuyData = predictions[0].model_price_buy;
            const modelPriceSellData = predictions[0].model_price_sell;
            const modelAdjustedPriceBuyData = predictions[0].model_adjusted_price_buy;
            const modelAdjustedPriceSellData = predictions[0].model_adjusted_price_sell;
            const decodedModelPriceBuy = this.decodeModelData(modelPriceBuyData);
            const decodedModelPriceSell = this.decodeModelData(modelPriceSellData);
            const decodedModelAdjustedPriceBuy = this.decodeModelData(modelAdjustedPriceBuyData);
            const decodedModelAdjustedPriceSell = this.decodeModelData(modelAdjustedPriceSellData);

            this.chartDataPricePrediction = [];
            this.chartDataPricePrediction.push(
              {
                group: 'price_prediction',
                name: 'Predicted Price Buy',
                values: decodedModelPriceBuy,
                color: `rgba(153, 102, 255, ${this.opacityLevelPrediction})`,
                labels: this.chartLabels,
              },
              {
                group: 'price_prediction',
                name: 'Predicted Price Sell',
                values: decodedModelPriceSell,
                color: `rgba(255, 159, 64, ${this.opacityLevelPrediction})`,
                labels: this.chartLabels,
              },       
             
            );
            this.predictionData['buy_price'] = decodedModelPriceBuy;
            this.predictionData['sell_price'] = decodedModelPriceSell;

          //// Make sure adjusted values only showup if not empty 
          if(decodedModelAdjustedPriceBuy.length > 0) {
            this.chartDataPricePrediction.push(      
              
              {
                group: 'price_prediction_adjusted',
                name: 'Predicted Price Buy (adjusted)',
                values: decodedModelAdjustedPriceBuy,
                color: `rgba(153, 102, 255, ${this.opacityLevelPrediction})`,
                labels: this.chartLabels,
              },
            );
            this.predictionData['buy_price_adjusted'] = decodedModelAdjustedPriceBuy;
          }
            if(decodedModelAdjustedPriceSell.length > 0) {
            this.chartDataPricePrediction.push(      
       
              {
                group: 'price_prediction_adjusted',
                name: 'Predicted Price Sell (adjusted)',
                values: decodedModelAdjustedPriceSell,
                color: `rgba(255, 159, 64, ${this.opacityLevelPrediction})`,
                labels: this.chartLabels,
              }
            );
            this.predictionData['sell_price_adjusted'] = decodedModelAdjustedPriceSell;
            }

          } else {
            //console.log('No predictions found in the response.');
          }
        } else {
          //console.log('No data found in the response.');
        }
      } catch (error) {
        //console.log('Error fetching price predictions:', error);
      }
    },
    async fetchBatteryActionsById(idValue) {
      try {
        this.chartDataPricePrediction = [];
        const bodyData = {
          id: idValue,
        };
        const url = `${this.subDataUrl}/battery_actions/by_id/get`;
        const response = await apiRequest('post', url, bodyData);

        if (response.errorCode === 0 && response.data) {
          const battery_actions = response.data;
          const actionPowerData = battery_actions.action_power;
          const decodedActionPower = this.decodeModelData(actionPowerData);

          this.removeGroup('battery_actions_prediction', 'power');
          this.chartDataPowerPrediction.push({
            group: 'battery_actions_prediction',
            name: 'Predicted Battery Actions',
            values: decodedActionPower,
            color: `rgba(200, 20, 150, ${this.opacityLevelPrediction})`,
            labels: this.chartLabels,
          });
          this.predictionData['battery'] = decodedActionPower;
          // console.log('This is the latest predicted battery actions: ', this.predictionData['battery']);
        } else {
          // console.log('No predictions found in the  battery actions by_id response.');
        }
      } catch (error) {
        //console.log('Error fetching battery actions predictions by id:', error);
      }
    },

    async fetchPricePredictionsById(idValue) {
      try {
        this.chartDataPricePrediction = [];
        const bodyData = {
          id: idValue,
        };
        const url = `${this.subDataUrl}/price_prediction/by_id/get`;
        const response = await apiRequest('post', url, bodyData);
        if (response.errorCode === 0 && response.data) {
          const prediction = response.data; // Single object, not array
          
          const modelPriceBuyData = prediction.model_price_buy;
          const modelPriceSellData = prediction.model_price_sell;
          const modelAdjustedPriceBuyData = prediction.model_adjusted_price_buy;
          const modelAdjustedPriceSellData = prediction.model_adjusted_price_sell;
          const decodedModelPriceBuy = this.decodeModelData(modelPriceBuyData);
          const decodedModelPriceSell = this.decodeModelData(modelPriceSellData);
          const decodedModelAdjustedPriceBuy = this.decodeModelData(modelAdjustedPriceBuyData);
          const decodedModelAdjustedPriceSell = this.decodeModelData(modelAdjustedPriceSellData);

          this.chartDataPricePrediction = [];
          this.chartDataPricePrediction.push(
            {
              group: 'price_prediction',
              name: 'Predicted Price Buy',
              values: decodedModelPriceBuy,
              color: `rgba(153, 102, 255, ${this.opacityLevelPrediction})`,
              labels: this.chartLabels,
            },
            {
              group: 'price_prediction',
              name: 'Predicted Price Sell',
              values: decodedModelPriceSell,
              color: `rgba(255, 159, 64, ${this.opacityLevelPrediction})`,
              labels: this.chartLabels,
            },       
            
          );
          this.predictionData['buy_price'] = decodedModelPriceBuy;
          this.predictionData['sell_price'] = decodedModelPriceSell;

        //// Make sure adjusted values only showup if not empty 
        if(decodedModelAdjustedPriceBuy.length > 0) {
          this.chartDataPricePrediction.push(      
            
            {
              group: 'price_prediction_adjusted',
              name: 'Predicted Price Buy (adjusted)',
              values: decodedModelAdjustedPriceBuy,
              color: `rgba(153, 102, 255, ${this.opacityLevelPrediction})`,
              labels: this.chartLabels,
            },
          );
          this.predictionData['buy_price_adjusted'] = decodedModelAdjustedPriceBuy;
        }
          if(decodedModelAdjustedPriceSell.length > 0) {
          this.chartDataPricePrediction.push(      
      
            {
              group: 'price_prediction_adjusted',
              name: 'Predicted Price Sell (adjusted)',
              values: decodedModelAdjustedPriceSell,
              color: `rgba(255, 159, 64, ${this.opacityLevelPrediction})`,
              labels: this.chartLabels,
            }
          );
          this.predictionData['sell_price_adjusted'] = decodedModelAdjustedPriceSell;
          }

        } else {
          // console.log('No predictions found in the price prediction by_id response.');
        }
      } catch (error) {
        //console.log('Error fetching price predictions by id:', error);
      }
    },
    async fetchHistoricalBatteryActionPredictions() {
      try {
        this.historicalBatteryActionsTimeList = []; // Independent list for dropdown

        const bodyData = {
          date: this.selectedDate,
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/battery_actions/all/get`;
        const response = await apiRequest('post', url, bodyData);
        if (response.errorCode === 0 && response.data) {
          const predictions = response.data;

          if (predictions.length > 0) {
            predictions.forEach((prediction, index) => {

              // Extract and format `date_added` (assuming it's in ISO format)
              if (prediction.date_added) {
                const dateObj = new Date(prediction.date_added);
                const formattedTime = dateObj.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                });

                this.historicalBatteryActionsTimeList.push(formattedTime);
                this.historicalBatteryActionsIdList.push(prediction.id);
                // console.log('Processing prediction:', index);
                // console.log('Date added:', prediction.date_added);
                // console.log('Formatted time:', formattedTime);
                // console.log('Time list so far:', this.historicalPricePredictionTimeList);
              }

              
            });
            // Use $nextTick to ensure the list is fully updated
            this.$nextTick(() => {
              this.batteryActionsSelectedTime = this.historicalBatteryActionsTimeList.length - 1;
            });
            // console.log('This is historicalBatteryActionsIdList: ', this.historicalBatteryActionsIdList);
            if(this.historicalBatteryActionsIdList.length > 0) {
              // console.log('This is this.historicalBatteryActionsIdList[this.historicalBatteryActionsTimeList.length - 1]: ', this.historicalBatteryActionsIdList[this.historicalBatteryActionsTimeList.length - 1]);
              this.fetchBatteryActionsById(this.historicalBatteryActionsIdList[this.historicalBatteryActionsTimeList.length - 1]);
            }

          } else {
            // console.log('No historical battery action predictions info found in the response.');
          }
        } else {
          // console.log('No data found in the response.');
        }
      } catch (error) {
        // console.log('Error fetching historical battery action predictions data:', error);
      }
    },

    async fetchHistoricalPricePredictions() {
      try {
        this.historicalPricePredictionTimeList = []; // Independent list for dropdown

        const bodyData = {
          model_date: this.selectedDate,
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/price_prediction/all/get`;
        const response = await apiRequest('post', url, bodyData);
        if (response.errorCode === 0 && response.data) {
          const predictions = response.data;

          if (predictions.length > 0) {
            predictions.forEach((prediction, index) => {

              // Extract and format `date_added` (assuming it's in ISO format)
              if (prediction.date_added) {
                const dateObj = new Date(prediction.date_added);
                const formattedTime = dateObj.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                });

                this.historicalPricePredictionTimeList.push(formattedTime);
                this.historicalPricePredictionIdList.push(prediction.id);
                // console.log('Processing prediction:', index);
                // console.log('Date added:', prediction.date_added);
                // console.log('Formatted time:', formattedTime);
                // console.log('Time list so far:', this.historicalPricePredictionTimeList);
              }

              
            });
            // Use $nextTick to ensure the list is fully updated
            this.$nextTick(() => {
              this.pricePredictionSelectedTime = this.historicalPricePredictionTimeList.length - 1;
            });
            // console.log('This is historicalPricePredictionTimeList: ', this.historicalPricePredictionTimeList);
            // console.log('This is historicalPricePredictionIdList: ', this.historicalPricePredictionIdList);
            if(this.historicalPricePredictionIdList.length > 0) {
              this.fetchPricePredictionsById(this.historicalPricePredictionIdList[this.historicalPricePredictionTimeList.length - 1]);
            }

          } else {
            // console.log('No historical predictions info found in the response.');
          }
        } else {
          // console.log('No data found in the response.');
        }
      } catch (error) {
        // console.log('Error fetching historical price predictions data:', error);
      }
    },
    async getNetCostAfterServiceFees() {
      try {
        const bodyData = {
          plantId: this.plantId,
          date: this.selectedDate,
        };
        const url = `${this.subDataUrl}/proxy/rx/localvoltapi/localvolt/get_summary`;
        const response = await apiRequest('post', url, bodyData);
          if (response.errorCode === 0 && response.data) {
            console.log('getNetCostAfterServiceFees response:', response);
            return response.data['dailyBalance'];
        } else {
          return 0;
        }
      } catch (error) {
        console.log('Error fetching net cost after service fees:', error);
        return 0;
      }
    },

    async fetchLoadPredictions() {
      try {
        this.removeGroup('load_prediction', 'power');
        const bodyData = {
          model_date: this.selectedDate,
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/load_prediction/get`;
        const response = await apiRequest('post', url, bodyData);
        if (response.errorCode === 0 && response.data) {
          const predictions = response.data;
          if (predictions.length > 0) {
            const modelPredictionLoadData = predictions[0].model_prediction_load;
            const modelPredictionLowerData = predictions[0].model_prediction_lower;
            const modelPredictionUpperData = predictions[0].model_prediction_upper;
            const modelAdjustedPredictionLoadData = predictions[0].model_prediction_load_adjusted;
            const decodedModelPredictionLoad = this.decodeModelData(modelPredictionLoadData);
            const decodedModelPredictionLower = this.decodeModelData(modelPredictionLowerData);
            const decodedModelPredictionUpper = this.decodeModelData(modelPredictionUpperData);
            const decodedAdjustedPredictionLoad = this.decodeModelData(modelAdjustedPredictionLoadData);
            
            this.removeGroup('load_prediction', 'power');
            this.chartDataPowerPrediction.push(
              {
                group: 'load_prediction',
                name: 'Predicted Load',
                values: decodedModelPredictionLoad,
                color: `rgba(153, 102, 255, ${this.opacityLevelPrediction})`,
                labels: this.chartLabels,
              },
              {
                group: 'load_prediction',
                name: 'Predicted Load Lower',
                values: decodedModelPredictionLower,
                color: `rgba(153, 102, 255, ${this.opacityLevelPrediction})`,
                labels: this.chartLabels,
              },
              {
                group: 'load_prediction',
                name: 'Predicted Load Upper',
                values: decodedModelPredictionUpper,
                color: `rgba(153, 102, 255, ${this.opacityLevelPrediction})`,
                labels: this.chartLabels,
              }
            );
            this.predictionData['load'] = decodedModelPredictionLoad;
            
            if(decodedAdjustedPredictionLoad.length > 0) {
              this.chartDataPowerPrediction.push(
              {
                group: 'load_prediction_adjusted',
                name: 'Predicted Load (adjusted - hourly updated)',
                values: decodedAdjustedPredictionLoad,
                color: `rgba(153, 102, 255, ${this.opacityLevelPrediction})`,
                // labels: this.prepareLabels(5, decodedAdjustedPredictionLoad.length - 1),
                labels: this.chartLabels,
              });
            }
          } else {
            //console.log('No predictions found in the response.');
          }
        } else {
          //console.log('No data found in the response.');
        }
      } catch (error) {
        //console.log('Error fetching load predictions:', error);
      }
    },
    async getPerformanceMetricsData() {
      try {
        const bodyData = {
          date: this.selectedDate,
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/performance_metrics/get`;
        const response = await apiRequest('post', url, bodyData);
        this.performanceMetricsData = {
          totalConsumption: 0,
          usageCost: 0,
          feedInCost: 0,
          originalCost: 0,
          costWithOptimisation: 0,
          originalCostPerkWh: 0,
          costWithOptimisationPerkWh: 0,
          savings: 0,
          netCostAfterServiceFees: 0,
        };
        // console.log('getPerformanceMetricsData response data:', response.data);
        if (response.errorCode == 0 && response.data != null) {
          this.performanceMetricsData['totalConsumption'] = response.data[0]['total_consumption'];
          this.performanceMetricsData['usageCost'] = response.data[0]['usage_cost'];
          this.performanceMetricsData['feedInCost'] = response.data[0]['feed_in_cost'];
          this.performanceMetricsData['originalCost'] = response.data[0]['original_cost'];
          this.performanceMetricsData['costWithOptimisation'] = response.data[0]['cost_with_optimisation'];
          this.performanceMetricsData['netCostAfterServiceFees'] = await this.getNetCostAfterServiceFees();
          this.performanceMetricsData['originalCostPerkWh'] = (this.performanceMetricsData['originalCost'] / this.performanceMetricsData['totalConsumption']).toFixed(2);
          this.performanceMetricsData['costWithOptimisationPerkWh'] = (this.performanceMetricsData['costWithOptimisation'] / this.performanceMetricsData['totalConsumption']).toFixed(2);
          this.performanceMetricsData['savings'] = (this.performanceMetricsData['originalCost'] - this.performanceMetricsData['costWithOptimisation']).toFixed(2);
          } else {
            // console.log('No getPerformanceMetricsData data found in the response.');

          }
        
      } catch (error) {
        // console.error('Error fetching getPerformanceMetricsData:', error);
      }
    },
    async getTimezoneData() {
      try {
        const bodyData = {
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/bridge/rx_data/plant/plant_info/get`;

        // Make the API request
        const response = await apiRequest('post', url, bodyData);
        
        // Initialize the timezone data map
        this.timezoneDataMap = {
          timezone_offset: 0,
          timezone_name: '',
        };

        // console.log('getTimezoneData response data:', response.data);

        // Check if the response is successful and contains data
        if (response.errorCode === 0 && response.data && response.data.length > 0) {
          this.timezoneDataMap.timezone_offset = Number(response.data[0]['timezone']);
          this.timezoneDataMap.timezone_name = response.data[0]['timezone_name'];
        } else {
          // console.log('No timezone data found in the response.');
        }

      } catch (error) {
        // console.error('Error fetching timezone data:', error);
      }
},

// async fetchGridPowerPredictions() {
//       try {
//         this.removeGroup('grid_prediction', 'power');
//         const bodyData = {
//           model_date: this.selectedDate,
//           plant_id: this.plantId,
//         };
//         const url = `${this.subDataUrl}/grid_prediction/get`;
//         const response = await apiRequest('post', url, bodyData);
//         if (response.errorCode === 0 && response.data) {
//           const grid_predictions = response.data;
//           if (grid_predictions.length > 0) {
//             const gridPowerData = grid_predictions[0].model_prediction_grid;
//             const decodedGridPower = this.decodeModelData(gridPowerData);

//             this.removeGroup('grid_prediction', 'power');
//             this.chartDataPowerPrediction.push({
//               group: 'grid_prediction',
//               name: 'Predicted Grid Power',
//               values: decodedGridPower,
//               color: `rgba(54, 162, 235, ${this.opacityLevelPrediction})`,
//               labels: this.chartLabels,
//             });
//             this.predictionData['grid_prediction'] = decodedGridPower;

//           } else {
//             //console.log('No grid prediction found in the response.');
//           }
//         } else {
//           //console.log('No grid prediction data found in the response.');
//         }
//       } catch (error) {
//         //console.log('Error fetching grid prediction:', error);
//       }
//     },

async calculateGridPowerPredictions() {
  setTimeout(() => {

  try {
    this.removeGroup('grid_prediction', 'power');
    
    // Check if all required data arrays exist
    if (this.predictionData['load'] && 
        this.predictionData['pv_adjusted'] && 
        this.predictionData['battery']) {


      // console.log('Starting new grid power calculation');
      // console.log('Load:', this.predictionData['load']);
      // console.log('PV:', this.predictionData['pv_adjusted']);
      // console.log('Battery:', this.predictionData['battery']);
      
      // Calculate grid prediction values using the provided formula
      const gridPowerData = [];
      for (let index = 0; index < this.predictionData['load'].length; index++) {
        const gridPrediction = parseFloat(
          (this.predictionData['pv_adjusted'][index] - 
          this.predictionData['load'][index] + 
          this.predictionData['battery'][index]
          ).toFixed(2)
        ) * -1;  // Multiply by -1 to invert the result
          
        gridPowerData.push(gridPrediction);
      }

      // for (let index = 0; index < 10; index++) {
      //   const gridPrediction1 = parseFloat(
      //     (this.predictionData['pv_adjusted'][index] - 
      //     this.predictionData['load'][index] + 
      //     this.predictionData['battery'][index]
      //     ).toFixed(2)
      //   );
      //   const gridPrediction2 = parseFloat(
      //     (this.predictionData['pv_adjusted'][index] - 
      //     this.predictionData['load'][index] + 
      //     (this.predictionData['battery'][index])
      //     ).toFixed(2)
      //   );
      //   const gridPrediction3 = parseFloat(
      //     (this.predictionData['pv_adjusted'][index] - 
      //     this.predictionData['load'][index] + 
      //     (this.predictionData['battery'][index]).to
      //     ).toFixed(2)
      //   );
      //   console.log('gridPrediction1:', gridPrediction1);
      //   console.log('gridPrediction2:', gridPrediction2);
      //   console.log('gridPrediction3:', gridPrediction3);
      //   return;
      // console.log('gridPowerData:', gridPowerData);
      // Add the calculated data to the chart
      this.chartDataPowerPrediction.push({
        group: 'grid_prediction',
        name: 'Predicted Grid Power',
        values: gridPowerData,
        color: `rgba(54, 162, 235, ${this.opacityLevelPrediction})`,
        labels: this.chartLabels,
      });
      
      // Store the calculated data
      this.predictionData['grid_prediction'] = gridPowerData;
      // console.log('Completed new grid power calculation');
    } else {
      // Handle missing data
      // console.log('Missing required prediction data for grid calculation');
    }
  } catch (error) {
    console.log('Error calculating grid prediction:', error);
  }

  }, 900);
},


async loadAndShowPlantDevices() {
    try {
        const bodyData = {
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/bridge/rx_data/plant/devices_info/get`;

        // Make the API request
        const response = await apiRequest('post', url, bodyData);
        
        // Initialize the data map
        this.plantDevicesDataMap = [];
        this.isPlantDevicesDataBoxVisible = true;

        // Check if the response is successful and contains data
        if (response.errorCode === 0 && response.data && response.data.length > 0) {
          this.plantDevicesDataMap = response.data;   
        } else {

          // console.log('No devices data found in the response.');
        }

      } catch (error) {
        // console.error('Error fetching plant devices data:', error);
      }
    },

    extractChartData(chartType) {
      let datasets = [];
      let filename = '';
      
      // Create filename with plant info
      const plantInfo = `PlantId-${this.plantId}_Alias-${this.alias || 'unknown'}_Timezone-${this.timezoneDataMap.timezone_name || 'unknown'}`;
      const safePlantInfo = plantInfo.replace(/[^a-zA-Z0-9_-]/g, '_');
      
      switch (chartType) {
        case 'power':
          datasets = this.getPowerDatasets();
          filename = `Power_Data_${this.selectedDate}_${safePlantInfo}.csv`;
          break;
        case 'price':
          datasets = this.getPriceDatasets();
          filename = `Price_Data_${this.selectedDate}_${safePlantInfo}.csv`;
          break;
        case 'soc':
          datasets = this.chartDataSocActual;
          filename = `SoC_Data_${this.selectedDate}_${safePlantInfo}.csv`;
          break;
        default:
          return;
      }

      // Filter out hidden datasets based on chart type
      let visibleDatasets = [];
      if (chartType === 'power') {
        visibleDatasets = datasets.filter(dataset => 
          !this.powerChartHiddenLegends.includes(dataset.name)
        );
      } else if (chartType === 'price') {
        visibleDatasets = datasets.filter(dataset => 
          !this.priceChartHiddenLegends.includes(dataset.name) &&
          !dataset.name.includes('Last Known') // Exclude warning columns
        );
      } else {
        // For SoC chart, all datasets are visible (no legend hiding functionality)
        visibleDatasets = datasets;
      }

      if (visibleDatasets.length === 0) {
        alert('No visible data to export');
        return;
      }

      // Create CSV content
      let csvContent = 'Time';
      
      // Add column headers
      visibleDatasets.forEach(dataset => {
        csvContent += `,${dataset.name}`;
      });
      csvContent += '\n';

      // Get the maximum length of all datasets
      const maxLength = Math.max(...visibleDatasets.map(dataset => dataset.values.length));
      
      // Add data rows
      for (let i = 0; i < maxLength; i++) {
        // Add time label (use first dataset's labels or generate time)
        const timeLabel = visibleDatasets[0]?.labels?.[i] || `${Math.floor(i/12)}:${String((i*5)%60).padStart(2, '0')}`;
        csvContent += timeLabel;
        
        // Add values for each dataset
        visibleDatasets.forEach(dataset => {
          const value = dataset.values[i] !== undefined ? dataset.values[i] : '';
          csvContent += `,${value}`;
        });
        csvContent += '\n';
      }

      // Create and download the file
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

 
  
    

  },
  created() {
    this.getQueryParams();
    this.triggerAllFetches();
    this.debouncedTriggerAllFetches = this.debounce(this.triggerAllFetches, 500);
    // Listen for environment changes
    eventBus.on('environment-changed', this.handleEnvironmentChange);
  },
  beforeUnmount() {
    // Remove the event listener when component is destroyed
    eventBus.off('environment-changed', this.handleEnvironmentChange);
  },
  watch: {
    selectedDate(newDate, oldDate) {
      if (newDate !== oldDate) {
        this.isLoading = true;
        
        // Set loading states BEFORE resetting data
        this.isLoadingActualData = true;
        this.isLoadingPredictionData = true;
        
        // Reset all data lists
        this.resetAllDataLists();
        
        // Trigger fetches with proper sequencing
        this.debouncedTriggerAllFetches();
      }
    },
  
  },
};
</script>

<style scoped>
.page-container {
  padding: 20px;
  position: relative;
}

.display-text-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  background-color: var(--bg-secondary);
  color: red;
}
.info-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 10px 10px 0;
}

.extra-info-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 10px 10px 0;
}



.chart-container {
  display: block;
  text-align: center;
  background: var(--card-bg);
  border-radius: 12px;
  box-shadow: 0 2px 10px var(--shadow-color);
  padding: 0rem 1rem 3rem 1rem;
}

.chart-container > h5 {
  margin: 0.2rem;
}

.extract-data-container {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}

.extract-data-button {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.extract-data-button:hover {
  background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.extract-data-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-button {
  display: flex;
  align-items: center;
  justify-content: end;
}

.toggle-box {
  border: 1px dashed #bddeb9;
  padding: 5px;
  border-radius: 8px;
  margin-top: 1%;
  margin-bottom: 1%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20%;
}


.toggle-button > p {
  padding: 0px;
  margin: 0px;
  display: inline-block;
}

.toggle-button button {
  padding: 4px 8px;
  margin: 4px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  font-size: 0.7rem;
}
.toggle-button .active {
  background-color: var(--custom-color1);
  color: white;
}

.bottom-pillar {
  height: 10rem;
}

.mini-info-box {
  color: white;
  font-size: 0.6rem;
  background-color: var(--text-tertiary);
  padding: 2px 4px;
  border-radius: 5px;
}


.scrollable-list {
    width: 100%;
    border-radius: 8px;
    display: block;
    overflow-y: auto;
    height: 270px;
    border: 1px solid var(--custom-color1);
    padding: 10px;
}

  .plant-button {
    font-size: 0.5rem;
    padding: 3px 6px;
  }

  .scrollable-list .item {
    display: inline-block;
    width: 12rem;
    margin: 15px;
    padding: 10px;
    border-radius: 8px;
    background-image: linear-gradient(135deg, var(--card-bg) 0%, var(--bg-secondary) 100%);
    border-radius: 12px;
    box-shadow: 0 2px 10px var(--shadow-color);
    padding: 0rem 1rem 2rem 1rem;
}

.device-info {
  margin-left: 20px;

}

.extra-details-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  padding: 10px;
  border: 0.2px solid var(--border-color);
  border-radius: 10px;
}


.version-selector-box {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 10px;
  border: 1px dotted var(--border-color);
  border-radius: 3px;
  background-color: var(--bg-secondary);
}

.version-selector-box p {
  margin: 0;
  white-space: nowrap;
}

.custom-aligner {
    margin-left: 0.26rem;
}

.per-metrics > h5 {
  text-align: center;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
}


.custom-button {
  cursor: pointer;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: none;
  border-radius: 5px;
  font-size: 14px;
}

.custom-button:hover {
  box-shadow: 0 2px 6px rgba(60,64,67,0.25);
  background: var(--custom-color1);
  color: white;
}

.single-button-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 750px) {

  .toggle-button button {
    font-size: 10px;
  }

  .mini-info-box{
    font-size: 10px;
  }

  .centered-flex-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
  }

  .toggle-box {
    flex-direction: column;
  }

  .toggle-button {
    flex-direction: row;
    align-self: center;
    align-items: center;
    margin-top: 10%;
  }

  .chart-container {
    margin-top: 2%;
    padding: 0rem 1rem 4rem 1rem;
  }

  .extract-data-button {
    font-size: 0.8rem;
    padding: 6px 12px;
  }
  
  .info-container {
    padding: 10px;
  }
  .extra-details-box {
    flex-direction: column;
  }

}

/* User Preferences Styles */
.user-preferences-container {
  background: var(--card-bg);
  border-radius: 12px;
  box-shadow: 0 2px 10px var(--shadow-color);
  padding: 1.5rem;
  margin: 1rem 0;
}

.user-preferences-container h6 {
  margin: 0 0 1rem 0;
  text-align: center;
  color: var(--text-primary);
  font-weight: 600;
}

.preferences-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.preference-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background-color: var(--bg-secondary);
  transition: all 0.2s ease;
}

.preference-item:hover {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
}

.preference-checkbox {
  width: 18px;
  height: 18px;
  margin-right: 0.75rem;
  cursor: pointer;
  accent-color: var(--custom-color1, #4CAF50);
}

.preference-label {
  font-size: 0.9rem;
  color: var(--text-primary);
  cursor: pointer;
  user-select: none;
  flex: 1;
  line-height: 1.4;
}

.preferences-actions {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.reset-button {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
  padding: 8px 16px;
  font-size: 0.9rem;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.reset-button:hover {
  background: linear-gradient(135deg, #ff5252 0%, #e53935 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

@media (max-width: 750px) {
  .preferences-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .preference-item {
    padding: 0.5rem;
  }
  
  .preference-label {
    font-size: 0.8rem;
  }
  
  .preference-checkbox {
    width: 16px;
    height: 16px;
    margin-right: 0.5rem;
  }
}

/* BMS Simulator Wrapper Styles */
.bms-simulator-wrapper {
  border: 3px solid #ff8c00;
  border-radius: 12px;
  margin: 1rem 0;
  padding: 0;
  background: var(--card-bg);
  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.2);
  position: relative;
}

.bms-simulator-wrapper::before {
  content: '';
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  background: linear-gradient(45deg, #ff8c00, #ffa500, #ff8c00);
  border-radius: 12px;
  z-index: -1;
  opacity: 0.3;
}
</style>
